import ROUTES from 'constants/routes';
import { ShowDialogParams, useDialog } from 'context/dialogContext';
import { useTranslation } from 'react-i18next';
import { useMatch, useNavigate } from 'react-router-dom';
import { resetAssessment } from 'store/assessment/model';
import { resetQuestionTimer } from 'store/assessment/questionTimer';

interface ShowPreventNavigateModalParams extends Omit<Partial<ShowDialogParams>, 'onConfirm'> {
  onConfirm: () => void;
}

const useNavigateWithReplace = () => {
  const navigateRRD = useNavigate();
  const { showDialog, closeDialog } = useDialog();
  const { t } = useTranslation();

  const showPreventNavigateModal = ({ onConfirm, ...rest }: ShowPreventNavigateModalParams) => {
    showDialog({
      title: t('assessment.interruptWarning.title'),
      content: t('assessment.interruptWarning.description'),
      confirmText: t('confirm'),
      cancelText: t('cancel'),
      onConfirm: async () => {
        onConfirm();
        resetAssessment();
        resetQuestionTimer();
        closeDialog();
      },
      ...rest,
    });
  };

  const isAssessmentView = !!useMatch(`${ROUTES.ASSESSMENT}/:id`);

  const navigate = (to: string, options: { replace?: boolean } = {}) => {
    navigateRRD(to, { ...options, replace: isAssessmentView });
  };

  return { navigate, isAssessmentView, showPreventNavigateModal };
};

export default useNavigateWithReplace;
